/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FunctionalSkillResource
 */
export interface FunctionalSkillResource {
    /**
     * 
     * @type {string}
     * @memberof FunctionalSkillResource
     */
    humanId: string;
    /**
     * 
     * @type {string}
     * @memberof FunctionalSkillResource
     */
    label: string;
}

/**
 * Check if a given object implements the FunctionalSkillResource interface.
 */
export function instanceOfFunctionalSkillResource(value: object): value is FunctionalSkillResource {
    if (!('humanId' in value) || value['humanId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function FunctionalSkillResourceFromJSON(json: any): FunctionalSkillResource {
    return FunctionalSkillResourceFromJSONTyped(json, false);
}

export function FunctionalSkillResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionalSkillResource {
    if (json == null) {
        return json;
    }
    return {
        
        'humanId': json['humanId'],
        'label': json['label'],
    };
}

export function FunctionalSkillResourceToJSON(value?: FunctionalSkillResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'humanId': value['humanId'],
        'label': value['label'],
    };
}

